import { useEffect } from "react";
import { Transition } from "history";

import { history } from "../history-router";

export const useBlocker = (
  blocker: (transition: Transition) => void,
  when = true,
): void => {
  useEffect(() => {
    if (!when) return;
    const unblock = history.block((tx) => {
      const autoUnblockingTx = {
        ...tx,
        retry() {
          unblock();
          tx.retry();
        },
      };
      blocker(autoUnblockingTx);
    });
    return unblock;
  }, [blocker, when]);
};

export default useBlocker;
